"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query PersonalEditorialCategoryOrPage(\n    $pageId: ID!\n    $landingPageId: ID\n    $includeThemeItems: Boolean! = false\n    $includeRoot: Boolean! = true\n  ) {\n    application {\n      ...PersonalEditorialArticlePage\n      ...PersonalEditorialCategoryPage\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.personalEditorialCategoryOrPageQuery = void 0;
var _fetching = require("@ori/fetching");
var _personalEditorialArticlePageFragment = require("./personalEditorialArticlePageFragment");
var _personalEditorialCategoryPageFragment = require("./personalEditorialCategoryPageFragment");
const personalEditorialCategoryOrPageQuery = exports.personalEditorialCategoryOrPageQuery = (0, _fetching.gql)(_templateObject(), _personalEditorialCategoryPageFragment.personalEditorialCategoryPageFragment, _personalEditorialArticlePageFragment.personalEditorialArticlePageFragment);
